import { apiService } from "@/services";
import { settings } from "@/settings";
import { MarketsClient } from "./GeneratedClients";

const marketRepository = new MarketsClient(settings.webApi.baseUrl, apiService.getApiClient());

export { marketRepository };
